import {
  CellWrapper,
  MultipleTextLabel,
} from "@smart/itops-sb-design-system-dom";

import { CellProps } from "../../types";

export const Staff = ({ row }: CellProps<{ staff: string }>) => (
  <MultipleTextLabel
    texts={row.original.staff.split(", ")}
    maxVisibleItems={2}
  />
);

export const FormTitle = ({ row }: CellProps<{ formTitle: string }>) => (
  <CellWrapper label={row.original.formTitle} size="medium" />
);
